// DASHBOARD

import React, {useState, useEffect} from "react";
import 'react-tabs/style/react-tabs.css';
import {useAuth0, withAuthenticationRequired} from "@auth0/auth0-react";
import {PageLoader} from "../components/PageLoader";
import AsyncSelect from "react-select/async";
import LaneService from "../services/LaneService";
import {v4 as uuidv4} from 'uuid';
import Select from "react-select";
import {Table} from "react-bootstrap";
import {confirmAlert} from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import {abbrRegion, customStyles, daysStyles, equipmentTypeStyles, radiusStyles} from "./Constants";
import Modal from "react-modal";
import UserService from "../services/UserService";
import Ticker from "../components/Ticker";
import LaneData from "../components/LaneData";
import '../styles/FreightLaneManager.css';




export const FreightLaneManager = () => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [pickCityDetails, setPickCityDetails] = useState(null);
  const [dropCityDetails, setDropCityDetails] = useState(null);
  const [pickCityFuelDetails, setPickCityFuelDetails] = useState(null);
  const [dropCityFuelDetails, setDropCityFuelDetails] = useState(null);
  const [dashReady, setDashReady] = useState(false);
  const [subscriptionType, setSubscriptionType] = useState('');
  const [data, setData] = useState([]);
  const [tickerData, setTickerData] = useState(['', '', '']); // For the 3 strings from /ticker/one
  const [tickerTwoData, setTickerTwoData] = useState(['', '', '']); // For the 3 strings from /ticker/two
  const [tickerLoading, setTickerLoading] = useState(true);
  const [showFavorites, setShowFavorites] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  function closeModal() { setIsOpen(false); }

  // Helper function to extract state name from stateName field when it contains "City State" format
  const getStateFromStateName = (cityValue, stateName) => {
    if (!stateName) return '';
    
    // Check if city is a ZIP code (numeric)
    const isZipCode = /^\d+$/.test(String(cityValue || ''));
    
    if (isZipCode && stateName.includes(' ')) {
      // For ZIP codes, stateName is in format "City State" (e.g., "Irving Texas")
      // Extract the state name (last word or words for multi-word states)
      const stateNameLower = stateName.toLowerCase().trim();
      
      // Handle multi-word states (check if stateName ends with these)
      const multiWordStates = [
        { pattern: /new hampshire$/i, name: 'New Hampshire' },
        { pattern: /new jersey$/i, name: 'New Jersey' },
        { pattern: /new mexico$/i, name: 'New Mexico' },
        { pattern: /new york$/i, name: 'New York' },
        { pattern: /north carolina$/i, name: 'North Carolina' },
        { pattern: /north dakota$/i, name: 'North Dakota' },
        { pattern: /south carolina$/i, name: 'South Carolina' },
        { pattern: /south dakota$/i, name: 'South Dakota' },
        { pattern: /west virginia$/i, name: 'West Virginia' },
        { pattern: /rhode island$/i, name: 'Rhode Island' },
        { pattern: /district of columbia$/i, name: 'District of Columbia' }
      ];
      
      // Check for multi-word states at the end
      for (const { pattern, name } of multiWordStates) {
        if (pattern.test(stateName)) {
          return name;
        }
      }
      
      // For single-word states, return the last word
      const parts = stateName.trim().split(/\s+/);
      return parts[parts.length - 1];
    }
    
    // For regular cities, return stateName as-is
    return stateName;
  };

  // Helper function to extract city name from stateName when city is a ZIP code
  const getCityNameFromStateName = (stateName) => {
    if (!stateName || !stateName.includes(' ')) return '';
    
    // Handle multi-word states (check if stateName ends with these)
    const multiWordStates = [
      'New Hampshire', 'New Jersey', 'New Mexico', 'New York',
      'North Carolina', 'North Dakota', 'South Carolina', 'South Dakota',
      'West Virginia', 'Rhode Island', 'District of Columbia'
    ];
    
    // Check for multi-word states and extract city name
    for (const state of multiWordStates) {
      if (stateName.endsWith(state)) {
        return stateName.slice(0, -(state.length + 1)).trim(); // +1 for the space
      }
    }
    
    // For single-word states, remove the last word to get city name
    const parts = stateName.trim().split(/\s+/);
    if (parts.length > 1) {
      parts.pop(); // Remove the state
      return parts.join(' '); // Return remaining as city name
    }
    
    return '';
  };

  // Helper function to format city display label
  const formatCityLabel = (cityValue, stateName) => {
    const isZipCode = /^\d+$/.test(String(cityValue || ''));
    
    if (isZipCode) {
      // For ZIP codes: "75063 - Dallas, TX"
      const cityName = getCityNameFromStateName(stateName);
      const state = getStateFromStateName(cityValue, stateName);
      const stateAbbr = abbrRegion(state, 'abbr') || state;
      return cityName ? `${cityValue} - ${cityName}, ${stateAbbr}` : `${cityValue}, ${stateAbbr}`;
    } else {
      // For regular cities: "City, TX"
      const state = getStateFromStateName(cityValue, stateName);
      const stateAbbr = abbrRegion(state, 'abbr') || state;
      return `${cityValue}, ${stateAbbr}`;
    }
  };

  // Fetch ticker data from API
  const fetchTickerData = async () => {
    try {
      const token = await getAccessTokenSilently();
      const data = await LaneService.getTickerOne(token);
      setTickerData(data);
      setTickerLoading(false);
    } catch (error) {
      console.error('Error fetching ticker data:', error);
    }
  };
  

  // Fetch ticker two data from API
  const fetchTickerTwoData = async () => {
    try {
      const token = await getAccessTokenSilently();
      const data = await LaneService.getTickerTwo(token);
      setTickerTwoData(data);
      setTickerLoading(false);
    } catch (error) {
      console.error('Error fetching ticker two data:', error);
    }
  };

  const {
    getAccessTokenSilently,
    user,
    isAuthenticated,
    isLoading
  } = useAuth0();

     // Custom green style for Pick City dropdown
   const pickCityGreenStyles = {
     control: (provided, state) => ({
       ...provided,
       background: 'none',
       borderColor: 'none',
       textAlign: 'left',
       fontWeight: 'normal',
       '&:hover': { borderColor: '#28a745' }
     }),
     option: (provided, state) => ({
       ...provided,
       backgroundColor: state.isSelected ? '#28a745' : state.isFocused ? '#d4edda' : '#e8f5e8',
       color: state.isSelected ? 'white' : 'black',
       textAlign: 'left',
       fontWeight: 'normal',
       padding: '10px 0 10px 5px',
       '&:hover': { backgroundColor: '#d4edda' }
     }),
     menu: (p) => ({ 
       ...p, 
       backgroundColor: '#e8f5e8',
       zIndex: 9999,
       position: 'absolute'
     }),
     singleValue: (p) => ({ ...p, textAlign: 'left', fontWeight: 'normal' }),
     input: (p) => ({ ...p, color: 'black', textAlign: 'left', fontWeight: 'normal' }),
     indicatorSeparator: () => ({ display: 'none' }),
     dropdownIndicator: (provided, state) => ({
       ...provided,
       color: '#495057',
       '&:hover': { color: '#495057' }
     })
   };

     // Custom red/pink style for Drop City dropdown
   const dropCityRedStyles = {
     control: (provided, state) => ({
       ...provided,
       background: 'none',
       border:'none',
       textAlign: 'left',
       fontWeight: 'normal',
       '&:hover': { borderColor: '#dc3545' }
     }),
     option: (provided, state) => ({
       ...provided,
       backgroundColor: state.isSelected ? '#dc3545' : state.isFocused ? '#f8d7da' : '#ffe8e8',
       color: state.isSelected ? 'white' : 'black',
       textAlign: 'left',
       fontWeight: 'normal',
       padding: '10px 0 10px 5px',
       '&:hover': { backgroundColor: '#f8d7da' }
     }),
     menu: (p) => ({ 
       ...p, 
       backgroundColor: '#ffe8e8',
       zIndex: 99999,
       position: 'absolute'
     }),
     singleValue: (p) => ({ ...p, textAlign: 'left', fontWeight: 'normal' }),
     input: (p) => ({ ...p, color: 'black', textAlign: 'left', fontWeight: 'normal' }),
     indicatorSeparator: () => ({ display: 'none' }),
     dropdownIndicator: (provided, state) => ({
       ...provided,
       color: '#495057',
       '&:hover': { color: '#495057' }
     })
   };

     // Custom gray style for Equipment dropdown
   const equipmentGrayStyles = {
     control: (provided, state) => ({
       ...provided,
       background:'none',
       border:'none',
       textAlign: 'left',
       borderRadius: '0',
       '&:hover': { background: '#e1e2e2' }
     }),
     option: (provided, state) => ({
       ...provided,
       backgroundColor: state.isSelected ? '#6c757d' : state.isFocused ? '#e9ecef' : '#f8f9fa',
       color: state.isSelected ? 'white' : 'black',
       textAlign: 'left',
       fontWeight: 'normal',
       padding: '10px 0 10px 5px',
       '&:hover': { backgroundColor: '#e9ecef' }
     }),
     menu: (p) => ({ 
       ...p, 
       backgroundColor: '#f8f9fa',
       zIndex: 9999,
       position: 'absolute'
     }),
     singleValue: (p) => ({ ...p, textAlign: 'left', fontWeight: 'normal' }),
     input: (p) => ({ ...p, color: 'black', textAlign: 'left', fontWeight: 'normal', fontSize: '9px' }),
     indicatorSeparator: () => ({ display: 'none' }),
     dropdownIndicator: (provided, state) => ({
       ...provided,
       color: '#495057',
       '&:hover': { color: '#495057' }
     })
   };

  const equipmentOptions = [
    {value: 'Dry Van', label: 'Dry Van'},
    {value: 'Flatbed', label: 'Flatbed'},
    {value: 'Reefer', label: 'Reefer'},
    {value: 'Auto Carrier', label: 'Auto Carrier'},
    {value: 'B-Train', label: 'B-Train'},
    {value: 'Box Truck', label: 'Box Truck'},
    {value: 'Cattle Trailer', label: 'Cattle Trailer'},
    {value: 'Conestoga', label: 'Conestoga'},
    {value: 'Container', label: 'Container'},
    {value: 'Conveyor', label: 'Conveyor'},
    {value: 'Double Drop', label: 'Double Drop'},
    {value: 'Drop Deck', label: 'Drop Deck'},
    {value: 'Dry Chassis', label: 'Dry Chassis'},
    {value: 'Dump Trailer', label: 'Dump Trailer'},
    {value: 'Hopper Bottom', label: 'Hopper Bottom'},
    {value: 'Lowboy', label: 'Lowboy'},
    {value: 'Maxi', label: 'Maxi'},
    {value: 'Moving Van', label: 'Moving Van'},
    {value: 'Pneumatic', label: 'Pneumatic'},
    {value: 'Power Only', label: 'Power Only'},
    {value: 'Reefer Double', label: 'Reefer Double'},
    {value: 'Removable Gooseneck', label: 'Removable Gooseneck'},
    {value: 'Sprinter', label: 'Sprinter'},
    {value: 'Step Deck', label: 'Step Deck'},
    {value: 'Straight Box Reefer', label: 'Straight Box Reefer'},
    {value: 'Straight Box', label: 'Straight Box'},
    {value: 'Stretch Trailer', label: 'Stretch Trailer'},
    {value: 'Tanker', label: 'Tanker'},
    {value: 'Truck and Trailer', label: 'Truck & Trailer'},
    {value: 'Walking Floor', label: 'Walking Floor'},
  ];

  const radiusOptions = [
    {value: 50, label: '50'},
    {value: 100, label: '100'},
    {value: 150, label: '150'},
    {value: 200, label: '200'}
  ];

  const dayRangeOptions = [
    {value: 120, label: '120'},
    {value: 60, label: '60'},
    {value: 30, label: '30'},
    {value: 7, label: '7'},
    {value: 3, label: '3'},
  ];

  const handlePickCityRadiusChange = (event, row_id) => {
    setData(prev => prev.map(item => {
      if (item.row_id === row_id) {
        return {
          ...item,
          request_pick_city_radius_old: item.request_pick_city_radius,
          request_pick_city_radius: event
        };
      }
      return item;
    }));
  };

  const handleDropRadiusChange = (event, row_id) => {
    setData(prev => prev.map(item => {
      if (item.row_id === row_id) {
        return {
          ...item,
          request_drop_city_radius_old: item.request_drop_city_radius,
          request_drop_city_radius: event
        };
      }
      return item;
    }));
  };

  const loadOptions = async (inputValue) => {
    const token = await getAccessTokenSilently();
    return LaneService.getCityOptions(inputValue, token).then(
      response => response,
      error => {
        if (error.response && error.response.status === 401) {
          // Handle 401 error
        }
      }
    );
  };

  const handleEquipmentChange = (event, row_id) => {
    setData(prev => prev.map(item => {
      if (item.row_id === row_id) {
        return {
          ...item,
          request_equipment_type_old: item.request_equipment_type,
          request_equipment_type: event
        };
      }
      return item;
    }));
  };

  const handleDayRangeValueChange = (event, row_id) => {
    setData(prev => prev.map(item => {
      if (item.row_id === row_id) {
        return {
          ...item,
          request_number_of_days_old: item.request_number_of_days,
          request_number_of_days: event
        };
      }
      return item;
    }));
  };

  const handlePickCityChange = (value, row_id) => {
    setData(prev => prev.map(item => {
      if (item.row_id === row_id) {
        return {
          ...item,
          request_pick_city_old: item.request_pick_city,
          request_pick_city: value
        };
      }
      return item;
    }));
  };

  const handleDropCityChange = (value, row_id) => {
    setData(prev => prev.map(item => {
      if (item.row_id === row_id) {
        return {
          ...item,
          request_drop_city_old: item.request_drop_city,
          request_drop_city: value
        };
      }
      return item;
    }));
  };

  async function openModal(dash_item) {
    const token = await getAccessTokenSilently();
    UserService.citySearch(dash_item.request_pick_city.id, token).then(response => {
      setPickCityDetails(response.data);
    });

    UserService.citySearch(dash_item.request_drop_city.id, token).then(response => {
      setDropCityDetails(response.data);
    });

    UserService.cityFuelSearch(dash_item.request_pick_city.id, token).then(response => {
      setPickCityFuelDetails(response.data);
    });

    UserService.cityFuelSearch(dash_item.request_drop_city.id, token).then(response => {
      setDropCityFuelDetails(response.data);
    });

    setIsOpen(true);
  }

  function clickHandler() {
    setData(data.concat({row_id: uuidv4(), id: null}));
  }

  async function moveRecord(event, upDown) {
    let dataLength = data.length;
    let rowIndex = data.findIndex(item => item['row_id'] === event);
    let message = "Move lane ?" + upDown;
    let recordNumber;

    if (data[rowIndex].request_pick_city_radius !== undefined && data[rowIndex].request_drop_city !== null) {
      let pickState = data[rowIndex].request_pick_city.stateName;
      let pickCity = data[rowIndex].request_pick_city.city;
      let dropCity = data[rowIndex].request_drop_city.city;
      let dropState = data[rowIndex].request_drop_city.stateName;
      recordNumber = data[rowIndex].recordOrder;
      message = 'Move lane pair ' + pickCity + ', ' + abbrRegion(pickState, 'abbr') + ' to ' + dropCity + ', ' + abbrRegion(dropState, 'abbr') + ' ' + upDown;
    }

    if (recordNumber === 1 && upDown === 'up') {
      confirmAlert({
        title: 'Cannot move the lane up. trying moving it down instead',
        message: message,
        buttons: [{ label: 'Ok', onClick: () => {} }]
      });
      return;
    }

    if (recordNumber === dataLength && upDown === 'down') {
      confirmAlert({
        title: 'Cannot move the lane down. trying moving it up instead',
        message: message,
        buttons: [{ label: 'Ok', onClick: () => {} }]
      });
      return;
    }

    const token = await getAccessTokenSilently();

    if (!data[rowIndex].id) {
      setData(data.filter(item => item.row_id !== event));
      return;
    }

    LaneService.shuffleDashBoardItem(user, data[rowIndex].id, upDown, token).then(
      response => {
        setData(response.data.filter(item => item.row_id !== 'mutate_data'));
      }
    );
  }

  async function deleteRow(event) {
    let rowIndex = data.findIndex(item => item['row_id'] === event);
    let message = "Confirm delete ?";
    if (data[rowIndex].request_pick_city_radius !== undefined && data[rowIndex].request_drop_city !== null) {
      let pickState = data[rowIndex].request_pick_city.stateName;
      let pickCity = data[rowIndex].request_pick_city.city;
      let dropCity = data[rowIndex].request_drop_city.city;
      let dropState = data[rowIndex].request_drop_city.stateName;
      message = 'Delete lane pair ' + pickCity + ', ' + abbrRegion(pickState, 'abbr') + ' to ' + dropCity + ', ' + abbrRegion(dropState, 'abbr');
    }

    const token = await getAccessTokenSilently();

    if (!data[rowIndex].id) {
      setData(data.filter(item => item.row_id !== event));
      return;
    }

    LaneService.deleteDashBoardItem(user, data[rowIndex].id, token).then(
      response => {
        setData(response.data.filter(item => item.row_id !== 'mutate_data'));
      }
    );
  }

  async function laneSearch(row_id) {
    let rowIndex = data.findIndex(item => item['row_id'] === row_id);
    let message = "Add city pairs, radius, days, and equipment before saving this lane.";
    if (
      data[rowIndex].request_pick_city !== undefined &&
      data[rowIndex].request_pick_city.city !== undefined &&
      data[rowIndex].request_pick_city.stateName !== undefined &&
      data[rowIndex].request_drop_city !== undefined &&
      data[rowIndex].request_drop_city.city !== undefined &&
      data[rowIndex].request_drop_city.stateName !== undefined &&
      data[rowIndex].request_equipment_type !== undefined &&
      data[rowIndex].request_equipment_type.value !== undefined &&
      data[rowIndex].request_pick_city_radius !== undefined &&
      data[rowIndex].request_pick_city_radius.value !== undefined &&
      data[rowIndex].request_drop_city_radius !== undefined &&
      data[rowIndex].request_drop_city_radius.value !== undefined &&
      data[rowIndex].request_number_of_days &&
      data[rowIndex].request_number_of_days.value
    ) {
      let pickState = data[rowIndex].request_pick_city.stateName;
      let pickCity = data[rowIndex].request_pick_city.city;
      let dropCity = data[rowIndex].request_drop_city.city;
      let dropState = data[rowIndex].request_drop_city.stateName;
      message = 'Save lane pair ' + pickCity + ', ' + abbrRegion(pickState, 'abbr') + ' to ' + dropCity + ', ' + abbrRegion(dropState, 'abbr');
    } else {
      confirmAlert({
        customUI: ({ onClose }) => (
          <div
            className="lane-warning-modal"
            style={{
              maxWidth: '380px',
              padding: '16px 20px',
              borderRadius: '10px',
              background: '#ffffff',
              boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
              fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
            }}
          >
            <h3
              style={{
                fontSize: '16px',
                margin: '0 0 6px',
                fontWeight: 600,
                color: '#222',
              }}
            >
              Add lane details
            </h3>
            <p
              style={{
                fontSize: '13px',
                margin: '0 0 8px',
                color: '#555',
                lineHeight: 1.4,
              }}
            >
              Before saving, please add:
            </p>
            <ul
              style={{
                fontSize: '12px',
                margin: '0 0 12px 18px',
                padding: 0,
                color: '#666',
              }}
            >
              <li>Pick and drop city pair</li>
              <li>Radius for pick and drop</li>
              <li>Days (lookback window)</li>
              <li>Equipment type</li>
            </ul>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button
                onClick={onClose}
                style={{
                  fontSize: '12px',
                  padding: '6px 14px',
                  borderRadius: '14px',
                  border: 'none',
                  background: '#006838',
                  color: '#fff',
                  cursor: 'pointer',
                  fontWeight: 500,
                }}
              >
                Got it
              </button>
            </div>
          </div>
        ),
      });
      return;
    }

    setDashReady(false);
    const token = await getAccessTokenSilently();
    LaneService.getLaneStatistics(
      data[rowIndex].request_pick_city.city,
      data[rowIndex].request_pick_city.stateName,
      data[rowIndex].request_drop_city.city,
      data[rowIndex].request_drop_city.stateName,
      data[rowIndex].request_equipment_type.value,
      data[rowIndex].request_pick_city_radius.value,
      data[rowIndex].request_drop_city_radius.value,
      data[rowIndex].request_number_of_days.value,
      token
    ).then(
      response => {
        const updatedData = data.map(x => (x.row_id === row_id ? {
          ...x,
          ratePerMile: response.data.thirtyDaysAverage.costPerMile,
          ratePerLoad: response.data.thirtyDaysAverage.averageLoadRate,
          confidenceInterval: response.data.thirtyDaysAverage.confidenceInterval,
          confidenceIntervalColor: response.data.thirtyDaysAverage.confidenceIntervalColor,
        } : x));
        setData(updatedData);
        LaneService.syncDashBoard(updatedData, token).then(
          response => {
            setData(response.data.filter(item => item.row_id !== 'mutate_data'));
            setDashReady(true);
          }
        );
      },
      error => {
        if (error.response && error.response.status === 401) {
          // auth errors
        }
      }
    );
  }

  async function favorite(row_id) {
    let rowIndex = data.findIndex(item => item['row_id'] === row_id);
    if (
      data[rowIndex].request_pick_city &&
      data[rowIndex].request_pick_city.city &&
      data[rowIndex].request_pick_city.stateName &&
      data[rowIndex].request_drop_city &&
      data[rowIndex].request_drop_city.city &&
      data[rowIndex].request_drop_city.stateName &&
      data[rowIndex].request_equipment_type &&
      data[rowIndex].request_equipment_type.value &&
      data[rowIndex].request_pick_city_radius &&
      data[rowIndex].request_pick_city_radius.value &&
      data[rowIndex].request_drop_city_radius &&
      data[rowIndex].request_drop_city_radius.value &&
      data[rowIndex].request_number_of_days &&
      data[rowIndex].request_number_of_days.value
    ) {
      const token = await getAccessTokenSilently();
      let favoriteValue = data[rowIndex].favorite;
      if (favoriteValue === null || favoriteValue === undefined) {
        data[rowIndex].favorite = true;
      } else {
        data[rowIndex].favorite = !data[rowIndex].favorite;
      }
      setData(data.filter(item => item.row_id !== 'mutate_data'));
      LaneService.syncDashBoard(data, token).then(
        response => {
          setData(response.data.filter(item => item.row_id !== 'mutate_data'));
        }
      );
    } else {
      // not eligible
    }
  }

  const callApi = async () => {
    const token = await getAccessTokenSilently();
    setDashReady(false);
    UserService.userSubscriptionStatusPair(token, user).then(
      response => {
        setSubscriptionType(response.data.subscriptionType);
      }
    );

    LaneService.loadDashBoard(token).then(
      response => {
        setData(response);
        setDashReady(true);
      }
    );
  };

  useEffect(() => {
    // Only proceed if Auth0 is not loading and user is authenticated
    if (!isLoading && isAuthenticated) {
      callApi();
      fetchTickerData();
      fetchTickerTwoData();
    }
  }, [isLoading, isAuthenticated]); // Add dependencies to re-run when auth state changes

  // Close filter dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isFilterOpen && !event.target.closest('.filter-dropdown')) {
        setIsFilterOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isFilterOpen]);

  // Filter data based on showFavorites state
  const filteredData = showFavorites ? data.filter(item => item.favorite) : data;

  return (
    <div className="container-fluid my-dashboard-container">

      {!dashReady && (
        <div style={{ width: '100%', textAlign: 'center' }}>
          <PageLoader />
          <span className="loader-text" style={{ textAlign: 'center', display: 'block', width: '100%', fontSize: '14px', color: '#666', marginTop: '8px' }}>Loading your dashboard with real-time pricing data...</span>
        </div>
      )}

      {dashReady && (
        <div className="dashboard-text">
          <div className="container-fluid"></div>



                     <div className="grid-container">
                       {/* Filter Button */}
                       <div className="filter-button-container">
                         <div className={`filter-dropdown ${isFilterOpen ? 'active' : ''}`}>
                           <button
                             onClick={() => setIsFilterOpen(!isFilterOpen)}
                             className="filter-button"
                           >
                             {showFavorites ? 'SHOW FAVORITES' : 'SHOW ALL'}
                             <i className="bi bi-chevron-down chevron-icon"></i>
                           </button>
                           
                           {isFilterOpen && (
                             <div className="filter-dropdown-menu">
                               <button
                                 onClick={() => {
                                   setShowFavorites(false);
                                   setIsFilterOpen(false);
                                 }}
                                 className={`filter-dropdown-item ${!showFavorites ? 'active' : ''}`}
                               >
                                 SHOW ALL
                               </button>
                               <button
                                 onClick={() => {
                                   setShowFavorites(true);
                                   setIsFilterOpen(false);
                                 }}
                                 className={`filter-dropdown-item ${showFavorites ? 'active' : ''}`}
                               >
                                 SHOW FAVORITES
                               </button>
                             </div>
                           )}
                         </div>
                       </div>
                       
                       {/* CSS Grid Layout */}
                       <div className="lane-grid">
                         
                         {/* Header Row */}
                         <div>
                           <span type="button" data-toggle="tooltip" data-placement="top" title="Reorder lanes">
                             <i className="bi bi-chevron-up" style={{ display: "block", marginBottom: "2px" }}></i>
                             <i className="bi bi-chevron-down" style={{ display: "block" }}></i>
                           </span>
                         </div>
                         
                         <div>
                           <span type="button" data-toggle="tooltip" data-placement="top" title="Equipment - Dry Van, Reefer ...">
                             Equipment
                           </span>
                         </div>
                         
                         <div>
                           <span type="button" data-toggle="tooltip" data-placement="top" title="Select a Pick City or Zip Code">
                             PICK CITY/DROP
                           </span>
                         </div>
                         
                         <div>
                           <span type="button" data-toggle="tooltip" data-placement="top" title="Select radius in miles for Pick City or Zip Code">
                             RADIUS
                           </span>
                         </div>
                         
                         <div>
                           <span type="button" data-toggle="tooltip" data-placement="top" title="Diesel price for Pick City">
                             DIESEL $
                           </span>
                         </div>
                         
                         <div>
                           <span type="button" data-toggle="tooltip" data-placement="top" title="Select a Drop City or Zip Code">
                             DROP CITY/ZIP
                           </span>
                         </div>
                         
                         <div>
                           <span type="button" data-toggle="tooltip" data-placement="top" title="Select radius in miles for Drop City or Zip Code">
                             RADIUS
                           </span>
                         </div>
                         
                         <div>
                           <span type="button" data-toggle="tooltip" data-placement="top" title="Diesel price for Drop City">
                             DIESEL $
                           </span>
                         </div>
                         
                         <div>
                           <span type="button" data-toggle="tooltip" data-placement="top" title="Last number of days">
                             DAYS
                           </span>
                         </div>
                         
                         <div>
                           <span type="button" title="Cost of a mile in Dollars">$/MILE</span>
                         </div>
                         
                         <div>
                           <span type="button" title="Total lane price in Dollars">$/LOAD</span>
                         </div>
                         
                         <div>
                           <span type="button" title="Confidence Index">CI</span>
                         </div>
                         
                         <div>
                           MORE
                         </div>

                         {/* Data Rows */}
                         {filteredData.map(dash_item => (
                           <React.Fragment key={dash_item.row_id}>
                             {/* Reorder Column */}
                             <div>
                               <div>
                                 <button
                                   onClick={() => moveRecord(dash_item.row_id, 'up')}
                                   title="Move Up">
                                   <i className="bi bi-chevron-up"></i>
                                 </button>
                                 <button
                                   onClick={() => moveRecord(dash_item.row_id, 'down')}
                                   title="Move Down">
                                   <i className="bi bi-chevron-down"></i>
                                 </button>
                               </div>
                             </div>

                             {/* Equipment Column */}
                             <div>
                               <Select
                                 label="What equipment"
                                 options={equipmentOptions}
                                 styles={equipmentGrayStyles}
                                 value={dash_item.request_equipment_type}
                                 onChange={event => handleEquipmentChange(event, dash_item.row_id)}
                                 menuPlacement="auto"
                                 menuPosition="fixed"
                               />
                             </div>

                             {/* Pick City Column */}
                             <div>
                               <AsyncSelect
                                 menuPlacement="auto"
                                 menuPosition="fixed"
                                 cacheOptions
                                 styles={pickCityGreenStyles}
                                 defaultOptions
                                 value={dash_item.request_pick_city}
                                 getOptionLabel={e => formatCityLabel(e.city, e.stateName)}
                                 getOptionValue={e => e.city}
                                 loadOptions={loadOptions}
                                 onChange={event => handlePickCityChange(event, dash_item.row_id)}
                               />
                             </div>

                             {/* Pick Radius Column */}
                             <div>
                               <Select
                                 label="What radius"
                                 options={radiusOptions}
                                 styles={pickCityGreenStyles}
                                 value={dash_item.request_pick_city_radius}
                                 onChange={event => handlePickCityRadiusChange(event, dash_item.row_id)}
                                 menuPlacement="auto"
                                 menuPosition="fixed"
                               />
                             </div>

                             {/* Pick Diesel Column */}
                             <div>
                               <div>
                                 {dash_item.pickCityFuelObject?.gas_prices?.[0]?.average ? (
                                   <span>
                                     {typeof dash_item.pickCityFuelObject.gas_prices[0].average === 'string' 
                                       ? dash_item.pickCityFuelObject.gas_prices[0].average 
                                       : `$${Number(dash_item.pickCityFuelObject.gas_prices[0].average).toFixed(2)}`
                                     }
                                   </span>
                                 ) : (
                                   <span>N/A</span>
                                 )}
                               </div>
                             </div>

                             {/* Drop City Column */}
                             <div>
                               <AsyncSelect
                                 cacheOptions
                                 styles={dropCityRedStyles}
                                 defaultOptions
                                 value={dash_item.request_drop_city}
                                 getOptionLabel={e => formatCityLabel(e.city, e.stateName)}
                                 getOptionValue={e => e.city}
                                 loadOptions={loadOptions}
                                 onChange={event => handleDropCityChange(event, dash_item.row_id)}
                                 menuPlacement="auto"
                                 menuPosition="fixed"
                               />
                             </div>

                             {/* Drop Radius Column */}
                             <div>
                               <Select
                                 label="What radius"
                                 styles={dropCityRedStyles}
                                 options={radiusOptions}
                                 value={dash_item.request_drop_city_radius}
                                 onChange={event => handleDropRadiusChange(event, dash_item.row_id)}
                                 menuPlacement="auto"
                                 menuPosition="fixed"
                               />
                             </div>

                             {/* Drop Diesel Column */}
                             <div>
                               <div>
                                 {dash_item.dropCityFuelObject?.gas_prices?.[0]?.average ? (
                                   <span>
                                     {typeof dash_item.dropCityFuelObject.gas_prices[0].average === 'string' 
                                       ? dash_item.dropCityFuelObject.gas_prices[0].average 
                                       : `$${Number(dash_item.dropCityFuelObject.gas_prices[0].average).toFixed(2)}`
                                     }
                                   </span>
                                 ) : (
                                   <span>N/A</span>
                                 )}
                               </div>
                             </div>

                             {/* Days Column */}
                             <div>
                               <Select
                                 label="What day"
                                 styles={{
                                   ...equipmentGrayStyles,
                                   control: (provided, state) => ({
                                     ...equipmentGrayStyles.control(provided, state),
                                     // minWidth: '70px',
                                     // width: '70px'
                                   })
                                 }}
                                 options={dayRangeOptions}
                                 value={dash_item.request_number_of_days}
                                 onChange={event => handleDayRangeValueChange(event, dash_item.row_id)}
                                 menuPlacement="auto"
                                 menuPosition="fixed"
                               />
                             </div>

                             {/* $/Mile Column */}
                             <div>
                               <div>
                                 {dash_item.ratePerMile ? (
                                   <span>
                                     ${(Math.round(dash_item.ratePerMile * 100) / 100).toFixed(2)}
                                   </span>
                                 ) : (
                                   <span>N/A</span>
                                 )}
                               </div>
                             </div>

                             {/* $/Load Column */}
                             <div>
                               <div>
                                 {dash_item.ratePerLoad ? (
                                   <span>
                                     ${(Math.round(dash_item.ratePerLoad * 100) / 100).toFixed(0)}
                                   </span>
                                 ) : (
                                   <span>N/A</span>
                                 )}
                               </div>
                             </div>

                             {/* CI Column */}
                             <div>
                               <div>
                                 <span style={{ 
                                   color: dash_item.confidenceIntervalColor, 
                                 }}>
                                   {dash_item.confidenceInterval}
                                 </span>
                               </div>
                             </div>

                             {/* MORE Column */}
                             <div>
                               <div>
                                 <div>
                                   {/* Favorite (star) */}
                                   <button
                                     onClick={() => favorite(dash_item.row_id)}
                                     id={dash_item.row_id}
                                     className="btn-icon"
                                     title={dash_item.favorite ? "Unfavorite" : "Favorite"}
                                     aria-label={dash_item.favorite ? "Unfavorite" : "Favorite"}
                                   >
                                     {dash_item.favorite ? (
                                       <i className="bi bi-star-fill star-active"></i>
                                     ) : (
                                       <i className="bi bi-star"></i>
                                     )}
                                   </button>

                                   {/* Save (refresh) */}
                                   <button
                                     onClick={() => laneSearch(dash_item.row_id)}
                                     id={dash_item.row_id}
                                     className="btn-icon"
                                     title="Refresh / Save"
                                     aria-label="Refresh / Save"
                                   >
                                     <i className="bi bi-arrow-clockwise"></i>
                                   </button>

                                   {/* Info (folder / download) */}
                                   {(subscriptionType === 'Gold' || subscriptionType === 'Platinum') && (
                                     <button
                                       onClick={() => openModal(dash_item)}
                                       className="btn-icon"
                                       title="Details"
                                       aria-label="Details"
                                     >
                                       <i className="bi bi-folder2-open"></i>
                                     </button>
                                   )}

                                   {/* Delete (cross) */}
                                   <button
                                     onClick={() => deleteRow(dash_item.row_id)}
                                     id={dash_item.row_id}
                                     className="btn-icon"
                                     title="Delete"
                                     aria-label="Delete"
                                   >
                                     <i className="bi bi-x-circle"></i>
                                   </button>
                                 </div>
                               </div>
                             </div>
                           </React.Fragment>
                         ))}
                       </div>
                     </div>

          <div className="add-lane-button-container">
            <button
              onClick={clickHandler}
              type="button"
              className="add-lane-button"
            >
              <i className="bi bi-plus-lg"></i>ADD LANE
            </button>
          </div>

          {/* Freight Lane Information Block */}
          <div className="ticker-block">
            <div className="ticker-grid">
              {tickerData.map((tickerString, index) => (
                <div key={index} className="ticker-item">
                  {/* Top line - Route with segmented display */}
                  <div className="ticker-line">
                    {(typeof tickerString?.line1 === 'string' ? tickerString.line1 : "").split('').map((char, charIndex) => (
                      <div key={charIndex} className={`ticker-char ${char === ' ' ? 'space' : 'white-text'}`}>
                        {char === ' ' ? '' : char}
                      </div>
                    ))}
                  </div>
                  
                  {/* Bottom line - Rate, RF, Distance with segmented display */}
                  <div className="ticker-line">
                    {(typeof tickerString?.line2 === 'string' ? tickerString.line2 : "LOADING").split('').map((char, charIndex) => (
                      <div key={charIndex} className={`ticker-char ${char === ' ' ? 'space' : 'orange-text'}`}>
                        {char === ' ' ? '' : char}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Second Ticker Block - Ticker Two */}
          <div className="ticker-block">
            <div className="ticker-grid">
              {tickerTwoData.map((tickerString, index) => (
                <div key={index} className="ticker-item">
                  {/* Top line - Route with segmented display */}
                  <div className="ticker-line">
                    {(typeof tickerString?.line1 === 'string' ? tickerString.line1 : "").split('').map((char, charIndex) => (
                      <div key={charIndex} className={`ticker-char ${char === ' ' ? 'space' : 'white-text'}`}>
                        {char === ' ' ? '' : char}
                      </div>
                    ))}
                  </div>
                  
                  {/* Bottom line - Rate, RF, Distance with segmented display */}
                  <div className="ticker-line">
                    {(typeof tickerString?.line2 === 'string' ? tickerString.line2 : "LOADING").split('').map((char, charIndex) => (
                      <div key={charIndex} className={`ticker-char ${char === ' ' ? 'space' : 'orange-text'}`}>
                        {char === ' ' ? '' : char}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>


          {/* Lane Data Component */}
          <div className="lane-data-container">
            <LaneData/>
          </div>

      
        </div>
      )}
    </div>
  );
};

export default withAuthenticationRequired(FreightLaneManager, {
  onRedirecting: () => <PageLoader/>,
});